import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import './TransactionAmountSection.scss';

import { hasError, ReactHookFormErrorMessage } from '../base/ErrorFieldMessage';
import { CustomTitleLabel } from '../earning/CustomBaseComponments';
import DiscountSection from './DiscountSection';
import { Button } from 'react-bootstrap';
import { DISCOUNT_TYPE, DISCOUNT_VALUE_TYPE } from 'config/CustomEnums';
import CustomTitleWithInput from 'components/base/CustomTitleWithInput';


function TransactionAmountSection() {
  const { watch, setValue, formState } = useFormContext();
  const { errors } = formState;

  const paidAmountField = 'paidAmount';
  const totalValueField = 'totalValue';
  const totalValueFormatField = 'totalValueFormat';
  const cashDollarField = 'pointToCash';
  const shippingFeeField = 'shippingFee';
  const otherChargeField = 'otherCharge';
  const discountsField = 'discounts';
  const discountAmountField = 'discountAmount';
  const totalQuantityField = 'totalQuantity';
  const netSalesField = 'netSales';

  const paidAmount = watch(paidAmountField);
  const totalValue = watch(totalValueField);
  const cashDollar = watch(cashDollarField);
  const shippingFee = watch(shippingFeeField);
  const otherCharge = watch(otherChargeField);
  const discounts = watch(discountsField);
  const discountAmount = watch(discountAmountField);
  const totalQuantity = watch(totalQuantityField);
  const netSales = watch(netSalesField);

  useEffect(() => {
    if (!discounts || discounts?.length < 1) {
      setValue(
        discountsField,
        [{
          type: DISCOUNT_TYPE.TRANSACTION,
          valueType: DISCOUNT_VALUE_TYPE.PERCENTAGE,
          value: null,
          code: null,
        }],
        { shouldDirty: true, });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className="first-section-title">AMOUNT</div>

      <CustomTitleWithInput
        type='number'
        title="Total quantity (optional)"
        defaultValue={totalQuantity}
        setValue={(value) => {
          setValue(totalQuantityField, value, { shouldDirty: true, });
        }}
      />

      <CustomTitleWithInput
        type='number'
        title="Shipping fee (optional)"
        defaultValue={shippingFee}
        setValue={(value) => {
          setValue(shippingFeeField, value, { shouldDirty: true, });
        }}
        per="HK$"
      />

      <CustomTitleWithInput
        type='number'
        title="Other charge (optional)"
        defaultValue={otherCharge}
        setValue={(value) => {
          setValue(otherChargeField, value, { shouldDirty: true, });
        }}
        per="HK$"
      />

      <CustomTitleWithInput
        type='number'
        title="Total discount (optional)"
        defaultValue={discountAmount}
        setValue={(value) => {
          setValue(discountAmountField, value, { shouldDirty: true, });
        }}
        per="HK$"
      />

      <CustomTitleWithInput
        type='number'
        title="Cash dollar (optional)"
        defaultValue={cashDollar}
        setValue={(value) => {
          setValue(cashDollarField, value, { shouldDirty: true, });
        }}
        per="HK$"
      />

      <CustomTitleWithInput
        type='number'
        title="Paid amount (offline POS) (optional)"
        defaultValue={paidAmount}
        setValue={(value) => {
          setValue(paidAmountField, value, { shouldDirty: true, });
        }}
        per="HK$"
      />

      <CustomTitleWithInput
        type='number'
        title="Transaction net sales (optional)"
        defaultValue={netSales}
        setValue={(value) => {
          setValue(netSalesField, value, { shouldDirty: true, });
        }}
        per="HK$"
      />

      <CustomTitleWithInput
        type='number'
        title="Eligible total"
        defaultValue={totalValue}
        setValue={(value) => {
          setValue(totalValueField, value, { shouldDirty: true, });
        }}
        per="HK$"
        customClass={
          hasError(errors, totalValueField) ||
            hasError(errors, totalValueFormatField)
            ? "error-field"
            : ""
        }
      />
      <ReactHookFormErrorMessage errors={errors} id={totalValueField} />
      <ReactHookFormErrorMessage errors={errors} id={totalValueFormatField} />

      <div className='multiple-discounts'>
        {discounts?.map((value, index) => <DiscountSection index={index} />)}
        <div>
          <Button
            onClick={() => {
              const tempArray = [].concat(discounts);
              const value = {
                type: DISCOUNT_TYPE.TRANSACTION,
                valueType: DISCOUNT_VALUE_TYPE.PERCENTAGE,
                value: null,
                code: null,
              };
              tempArray.push(value);
              setValue(discountsField, tempArray, { shouldDirty: true, });
            }}
            className="btn-add-button-common"
          >
            Add discount
          </Button>
        </div>
      </div>
    </>
  );
}

export default TransactionAmountSection;
